module.exports = __webpack_public_path__ + "img/空空如也.77f9661e.png";